import { TableCell } from '@/components/ui/table';
import type { CarryVestingStatus } from '@/types/carryFund';
import { formatDays } from '../funds/carryFundValues';

interface CarryVestingDaysCellProps {
  vestingStatus: CarryVestingStatus;
  vestedDays: number | null;
  unvestedDays: number | null;
}

export function CarryVestingDaysCell({
  vestingStatus,
  vestedDays,
  unvestedDays,
}: CarryVestingDaysCellProps) {
  const frozen = vestingStatus === 'FROZEN';
  if (!frozen && vestedDays === null) {
    return <TableCell className="text-right">—</TableCell>;
  }
  return (
    <TableCell className="text-right">
      <div className="text-emerald-600 dark:text-emerald-400">
        {frozen ? 'stopped' : `${formatDays(vestedDays ?? 0)} d`}
      </div>
      <div className="text-xs text-muted-foreground">
        {frozen ? 0 : formatDays(unvestedDays ?? 0)} remaining
      </div>
    </TableCell>
  );
}
